/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { axios } from '~/util/http/axioshttp';
import { queryOptions } from '@tanstack/react-query';
import type { PatientWoundsViewModel } from './PatientWoundsViewModel'; 

export function getWoundsOptions(stayId: string, onSuccess?: (result: PatientWoundsViewModel) => void) {
	return queryOptions({
		queryKey: ['wounds', stayId],
		queryFn: async () => {
			const url = '/_api/v1/homehealth/woundmanagement/queries/getwounds/' + stayId;
			const resp = await axios.get<PatientWoundsViewModel>(url);
			if(onSuccess) {
				onSuccess(resp.data);
			}
			return resp.data;
		},
        enabled: Boolean(stayId)
	});
}